import React from "react";
import { CustomNavLink } from "./CustomNavLink";

interface NavitagionProps {
  saveOnClick: (e: any, link: string) => void;
}

function NavigationBar({ saveOnClick }: NavitagionProps) {
  return (
    <div className="navbar grid grid-cols-2 sm:grid-cols-4 lg:flex-row lg:flex  mb-8 text-sk-navbar-text justify-center">
      <CustomNavLink
        text={"1. Lokalforening"}
        link={"lokalforening"}
        saveOnClick={saveOnClick}
      />
      <CustomNavLink
        text={"2. Styret"}
        link={"styret"}
        saveOnClick={saveOnClick}
      />
      <CustomNavLink
        text={"3. Eiendom"}
        link={"eiendom"}
        saveOnClick={saveOnClick}
      />
      <CustomNavLink
        text={"4. Aktiviter"}
        link={"aktiviteter"}
        saveOnClick={saveOnClick}
      />
      <CustomNavLink
        text={"5. Kurs/Opplæring/Samarbeid"}
        link={"kos"}
        saveOnClick={saveOnClick}
      />
      <CustomNavLink
        text={"6. Gaver og økonomiske bidrag"}
        link={"gbm"}
        saveOnClick={saveOnClick}
      />
      <CustomNavLink
        text={"7. Regnskapstabell"}
        link={"regnskapstabell"}
        saveOnClick={saveOnClick}
      />
      <CustomNavLink
        text={"8. Rapport"}
        link={"avslutt"}
        saveOnClick={saveOnClick}
      />
    </div>
  );
}

export default NavigationBar;
